import React from 'react';

export default function PrivateHeader() {
	return (
		<div>
			<h3>Private header placeholder</h3>
		</div>
	);
}
